(function(){

  function filterCurrencyDropdown(selectedCountryCodes) {
    const dropdown = document.getElementById('CurrencyList');
    if(dropdown) {
      const items = dropdown.querySelectorAll('.disclosure-list__item');
    
      items.forEach((item) => {
        const opt = item.querySelector('.disclosure-list__option');
        if (!opt) return;
        const countryCode = opt.getAttribute('data-value');
    
        if (selectedCountryCodes.includes(countryCode)) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
      }
  }

  

  filterCurrencyDropdown([ 'AT', 'BE', 'CZ', 'DK', 'FI', 'FR', 'DE', 'HU', 'IE', 'IT', 'NL', 'PL', 'PT', 'ES', 'SE', 'GB', 'TR', 'US']);
  
  // Australia (AUD $) = AU
  // Austria (EUR €) = AT
  // Belgium (EUR €) = BE
  // Bulgaria (BGN лв.) = BG
  // Canada (CAD $) = CA
  // Croatia (EUR €) = HR
  // Cyprus (EUR €) = CY
  // Czechia (CZK Kč) = CZ
  // Denmark (DKK kr.) = DK
  // Estonia (EUR €) = EE
  // Finland (EUR €) = FI
  // France (EUR €) = FR
  // Germany (EUR €) = DE
  // Greece (EUR €) = GR
  // Hong Kong SAR (HKD $) = HK
  // Hungary (HUF Ft) = HU
  // Ireland (EUR €) = IE
  // Israel (ILS ₪) = IL
  // Italy (EUR €) = IT
  // Japan (JPY ¥) = JP
  // Latvia (EUR €) = LV
  // Lithuania (EUR €) = LT
  // Luxembourg (EUR €) = LU
  // Malaysia (MYR RM) = MY
  // Malta (EUR €) = MT
  // Netherlands (EUR €) = NL
  // New Zealand (NZD $) = NZ
  // Norway (EUR €) = NO
  // Poland (PLN zł) = PL
  // Portugal (EUR €) = PT
  // Romania (RON Lei) = RO
  // Singapore (SGD $) = SG
  // Slovakia (EUR €) = SK
  // Slovenia (EUR €) = SI
  // South Korea (KRW ₩) = KR
  // Spain (EUR €) = ES
  // Sweden (SEK kr) = SE
  // Switzerland (CHF CHF) = CH
  // Turkey (TRY ₺) = TR
  // United Arab Emirates (AED د.إ) = AE
  // United Kingdom (GBP £) = GB
  // United States (USD $) = US

  
// EU countries data
const euCountries = [
    { code: "", name: "Select country" },
    { code: "turkey", name: "Turkey" , selected : true},
    /* { code: "germany", name: "Germany" },
    { code: "austria", name: "Austria" },
    { code: "belgium", name: "Belgium" },
    { code: "czech_republic", name: "Czech Republic" },
    { code: "denmark", name: "Denmark" },
    { code: "finland", name: "Finland" },
    { code: "france", name: "France" },
    { code: "hungary", name: "Hungary" },
    { code: "ireland", name: "Ireland" },
    { code: "italy", name: "Italy" },
    { code: "netherlands", name: "Netherlands" },
    { code: "poland", name: "Poland" },
    { code: "portugal", name: "Portugal" },
    { code: "spain", name: "Spain" },
    { code: "sweden", name: "Sweden" },
    { code: "uk", name: "United Kingdom" } */
];


// Function to create and insert the select box
function createCountrySelect() {
  
  const template = `
    <select id='countrySelect' value="turkey">
      ${euCountries.map(country => `<option value="${country.code}" ${country?.selected ? 'selected' : ''}>${country.name}</option>`).join('')}
    </select>`;
  
    // Insert the select box into the isSelectBoxExist 
    const isSelectBoxExist = document.getElementById("countrySelect");
    const languageBox = document.querySelector(".multi-selectors__item");
    if(isSelectBoxExist) isSelectBoxExist.remove();
    if (languageBox) languageBox.insertAdjacentHTML('afterend', template);
}
createCountrySelect();

let countryDrop = document.querySelector('#countrySelect');
if (countryDrop) {
    countryDrop.addEventListener('change', (e) => {
        const selectedCountry = e.target.value;
        if (selectedCountry === "") return; 
      
        if (selectedCountry !== 'turkey') {
            window.location.href = 'http://www.nutrade.eu/';
        }
    });
}





})();


/* === NUTRADE ERİŞİLEBİLİRLİK 2026-08-18 ================================
   aria-hidden="true" bir kapsayicinin icindeki link/butonlar klavye sekme
   sirasinda kaliyordu: ekran okuyucu "yok" diyor ama Tab tusu oraya gidiyor.
   PSI aria-hidden-focus. Kaynak: Flickity'nin pasif slaytlari ve PhotoSwipe.
   Cozum: gizliyken tabindex="-1", gorunur olunca eski degerine geri don.
   ====================================================================== */
(function ntA11yGizliOdak() {
  var SECICI = 'a[href],button,input,select,textarea,[tabindex]';
  function uygula() {
    document.querySelectorAll('[aria-hidden="true"]').forEach(function (kap) {
      kap.querySelectorAll(SECICI).forEach(function (e) {
        if (!e.hasAttribute('data-nt-eski-tabindex')) {
          e.setAttribute('data-nt-eski-tabindex', e.getAttribute('tabindex') || '');
        }
        e.setAttribute('tabindex', '-1');
      });
    });
    document.querySelectorAll('[data-nt-eski-tabindex]').forEach(function (e) {
      if (!e.closest('[aria-hidden="true"]')) {
        var eski = e.getAttribute('data-nt-eski-tabindex');
        if (eski) { e.setAttribute('tabindex', eski); } else { e.removeAttribute('tabindex'); }
        e.removeAttribute('data-nt-eski-tabindex');
      }
    });
  }
  function baslat() {
    uygula();
    new MutationObserver(function () {
      clearTimeout(window.__ntA11yT);
      window.__ntA11yT = setTimeout(uygula, 120);
    }).observe(document.body, {subtree: true, childList: true,
                               attributes: true, attributeFilter: ['aria-hidden']});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else { baslat(); }
})();
